import { Container, Graphics, Text } from '@pixi/react'
import { Assets, TextStyle } from 'pixi.js'
import { ErrorType, Image, isXinStarDemoMode, isXinStarPlayMode, t, useErrorPopupStore } from '@slot-nx/core'

import { useCallback } from 'react'
import errorIcon from '../../asset/images/popup/icon_error.png'
import btnOKnormal from '../../asset/images/popup/btn_popup_normal.png'
import btnOKhover from '../../asset/images/popup/btn_popup_hover.png'
import btnOKpressed from '../../asset/images/popup/btn_popup_click.png'

import {
  appScreen,
  Button,
  Draw,
} from '@slot-nx/core'
import { GrayBackground } from './GrayBackground'
import { gameConfig } from '../config'

Assets.addBundle('ErrorIcon', {
  errorIcon: {
    src: errorIcon,
    loadParser: 'loadTextures',
  },
  buttonOKnormal: {
    src: btnOKnormal,
    loadParser: 'loadTextures',
  },
  buttonOKhover: {
    src: btnOKhover,
    loadParser: 'loadTextures',
  },
  buttonOKpressed: {
    src: btnOKpressed,
    loadParser: 'loadTextures',
  },

})

export const ErrorPopup = () => {
  const width = 816
  const height = 515
  const errorPopupStore = useErrorPopupStore()

  const x = (appScreen.width - width) / 2
  const y = (appScreen.height - height) / 2

  const backgroundDraw = useCallback<Draw>((background) => {
    background.clear()
    background.beginFill('#0D0A02')
    background.drawRoundedRect(0, 0, width - 4, height, 10)
  }, [])

  const borderDraw = useCallback<Draw>((border) => {
    border.clear()
    border.lineStyle(2, '#DBD2CA', 1)
    border.drawRoundedRect(0, 0, width, height, 10)
  }, [])
  if (!errorPopupStore.isShow) return null

  const key = errorPopupStore.type?.toString() ?? ''
  const errorMessage = errorPopupStore.type ? t(key) : ''
  const disablePopupButton = (key === ErrorType.SignalRDisconnected || key === ErrorType.SessionExpired) && (isXinStarDemoMode() || isXinStarPlayMode())

  return (
    <GrayBackground name="ErrorPopup" width={gameConfig.resolution.width} height={gameConfig.resolution.height}>
      <Container position={[x, y]}>
        <Graphics draw={backgroundDraw} />
        <Graphics draw={borderDraw} />
        <Image
          x={(width - 140) / 2}
          y={disablePopupButton ? 80 : 44}
          width={140}
          height={114}
          name="ErrorIcon"
          image="errorIcon"
        />
        <Text
          text={errorMessage}
          x={width / 2}
          y={disablePopupButton ? 320 : 240}
          anchor={[0.5, 0.5]}
          style={
            new TextStyle({
              fontSize: 40,
              fontWeight: 'bold',
              fontFamily: 'Arial',
              fill: '#F0E1D4',
              align: 'center',
              wordWrap: true,
              breakWords: true,
              wordWrapWidth: 700,
              lineHeight: 60,
            })
          }
        />
        <Button
          name="ErrorCloseButton"
          x={(width - 270) / 2}
          y={380}
          width={270}
          height={84}
          onPress={() => {
            if (errorPopupStore.okCallback) errorPopupStore.okCallback()
          }}
          defaultView="buttonOKnormal"
          hoverView="buttonOKhover"
          pressedView="buttonOKpressed"
          visible={!disablePopupButton}
        />
        <Text
          text={t('error_popup_ok')}
          x={width / 2}
          y={423}
          anchor={[0.5, 0.5]}
          style={
            new TextStyle({
              fontSize: 40,
              fontWeight: 'bold',
              fontFamily: 'Arial',
              fill: '#F0E1D4',
              align: 'center',
              wordWrapWidth: 300,
              wordWrap: true,
              breakWords: true,
            })
          }
          visible={!disablePopupButton}
        />

      </Container>
    </GrayBackground>
  )
}
